import { render, staticRenderFns } from "./surveillanceUserInfo.vue?vue&type=template&id=61189bb7&scoped=true&"
import script from "./surveillanceUserInfo.vue?vue&type=script&lang=js&"
export * from "./surveillanceUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./surveillanceUserInfo.vue?vue&type=style&index=0&id=61189bb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61189bb7",
  null
  
)

export default component.exports